module.exports = __webpack_public_path__ + "img/slash_bell.b78afa74.png";